import React from 'react';
import { makeStyles } from '@mui/styles';

import { Dialog, AppBar, Toolbar, IconButton, DialogContent } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import ModalTransition from './ModalTransition';

const useStyles = makeStyles({
  appBar: {
    position: 'fixed',
    top: '0',
    width: '100%',
    zIndex: '10000',
  },
  toolBar: { minHeight: '0' },
  flex: {
    flex: 1,
  },
  closeBtn: {
    padding: '4px',
  },
  paperFullScreen: {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  paper: ({ marginTopDueToNesting = 0 }) => ({
    width: '100%',
    height: `calc(100% - ${marginTopDueToNesting}px)`,
    marginTop: `${marginTopDueToNesting}px`,
  }),
});

const FullScreenDialog = (
  ({
    title,
    isOpen,
    onExit,
    onClose,
    onEnter,
    children,
    className,
    modalIndex,
    titleStyles,
    appBarStyles,
    closeBtnStyles,
    paperFullScreenStyles,
    disableContainerPadding,
  }) => {
    const marginTopDueToNesting = modalIndex ? modalIndex * 32 : 0;

    const classes = useStyles({ marginTopDueToNesting });

    return (
    <Dialog
      fullScreen
      open={isOpen}
      onClose={onClose}
      className={className}
      TransitionComponent={ModalTransition}
      classes={{
        paperFullScreen: {...paperFullScreenStyles},
        paper: classes.paper,
      }}
      BackdropProps={{ style: {backgroundColor: 'rgba(0, 0, 0, 0.2)'} }}
      TransitionProps={{
        onExit
      }}>
      <AppBar
        className={classes.appBar}
        style={{
          ...appBarStyles, 
          marginTop: `${marginTopDueToNesting}px`,
        }}
        sx={{
          marginTop: `${marginTopDueToNesting}px`,
        }}
        >
        <Toolbar className={classes.toolBar}>
          <IconButton
            id={'close-modal-ui'}
            style={{
              paddingRight: '10px',
              ...closeBtnStyles,
            }}
            color="inherit"
            onClick={onClose}
            aria-label="Close"
            className={classes.closeBtn}
            size="large">
            <CloseIcon style={{ fontSize: '24px', color: '#fff' }}/>
          </IconButton>
          <span style={{ fontSize: '16px', ...titleStyles }}>{title}</span>
        </Toolbar>
      </AppBar>

      <DialogContent
        style={{
          padding: `${disableContainerPadding ? '0' : '20px'}`,
          marginTop: '28px',
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  )}
);

export default FullScreenDialog;
